"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bindAngularjsAngularExamplesToAngularJs = exports.AngularjsAngularExamplesModule = void 0;
const static_1 = require("@angular/upgrade/static");
const simple_angular_component_1 = require("./simple-angular/simple-angular.component");
const nested_angularjs_component_1 = require("./nested-angularjs/nested-angularjs.component");
const common_1 = require("@angular/common");
const core_module_1 = require("@core/core.module");
const planner_example_component_1 = require("./planner-example/planner-example.component");
const angular_hybrid_1 = require("@uirouter/angular-hybrid");
const i0 = __importStar(require("@angular/core"));
const i1 = __importStar(require("@uirouter/angular-hybrid"));
let ANGULAR_ROUTES_STATES = [
    // declare here all new routes you want to use
    // for this module
    {
        parent: 'app',
        name: 'angular-route',
        url: '/angular-route',
        component: nested_angularjs_component_1.NestedAngularjsComponent
    }
];
class AngularjsAngularExamplesModule {
}
exports.AngularjsAngularExamplesModule = AngularjsAngularExamplesModule;
AngularjsAngularExamplesModule.ɵfac = function AngularjsAngularExamplesModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AngularjsAngularExamplesModule)(); };
AngularjsAngularExamplesModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AngularjsAngularExamplesModule });
AngularjsAngularExamplesModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [common_1.CommonModule,
        core_module_1.CoreModule,
        angular_hybrid_1.UIRouterUpgradeModule.forChild({
            states: ANGULAR_ROUTES_STATES
        })] });
function bindAngularjsAngularExamplesToAngularJs(angular) {
    angular.directive('simpleAngular', (0, static_1.downgradeComponent)({ component: simple_angular_component_1.SimpleAngularComponent }));
    angular.directive('plannerExample', (0, static_1.downgradeComponent)({ component: planner_example_component_1.PlannerExampleComponent }));
}
exports.bindAngularjsAngularExamplesToAngularJs = bindAngularjsAngularExamplesToAngularJs;
